import React from "react";
import { Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./App.css";
import LoginNew from "./LandingPageNew/index";
import Login from "./LandingPage/index";
import Routing from "./Routes";

const App = () => {
  const slug = useParams();
  // console.log = function() {}
  // console.warn = function() {}
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/*" element={<Routing />} />
      </Routes>
    </>
  );
};

export default App;
